module.exports = __webpack_public_path__ + "static/media/Modern S VR.4d8b3da.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern S VR.mp3
// module id = AUqv
// module chunks = 12